import { InfoBox, lightColors, ModalFooter } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledLinkedinLink = styled.a`
  align-items: center;
  justify-content: center;

  border-radius: 0.5rem;
  display: inline-flex;
  max-width: 100%;
  cursor: pointer;
  font-size: 1.6rem;
  font-family: Ubuntu;
  gap: 0.6rem;
  height: 3.6rem;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  padding: 0.9rem 1.6rem;

  background-color: ${lightColors.info.main};
  border: none;
  color: ${({ theme }) => theme.colors.white};
  margin: 1.6rem 0 2.4rem;

  svg {
    height: 1.9rem;
    width: 1.2rem;
    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  &:hover:not(:disabled) {
    background-color: ${lightColors.info.main};
    color: ${({ theme }) => theme.colors.white};
    filter: opacity(0.9);
  }
`;

export const StyledContentWrapper = styled.div`
  margin-top: 4.6rem;

  p[data-title='title'] {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    margin-bottom: 0.8rem;
  }
`;

export const StyledInfoBox = styled(InfoBox)`
  margin-top: 1.6rem;

  p {
    word-break: break-word;
    padding-right: 2rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
    align-items: start;
  }
`;
export const StyledModalFooter = styled(ModalFooter)`
  margin-top: 2.6rem;
  background-color: red;
`;
